import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "cv0gtuav",
  dataset: "production",
  useCdn: true
})

